import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/finalclipstonedesginlogo-removebg-preview.png';

const Footer = () => {
  return (
    <footer className="footer sm:footer-horizontal bg-base-200 text-base-content w-full p-6 sm:p-10 box-border">
      <aside>
        <Link to="/" className="flex items-center gap-3 no-underline">
          <img
            src={Logo}
            alt="Clipstone Logo"
            className="w-16 h-16 object-contain"
          />
        </Link>
        <p className="mt-2 text-sm leading-relaxed">
          <strong className="font-bold text-base">Clipstone Miners Welfare</strong>
          <br />
          Providing for our community for over 90+ years.
          <br />
          Mansfield Road, Clipstone, Mansfield NG21 9AA
        </p>
      </aside>

      <nav>
        <h6 className="footer-title uppercase text-xs font-bold tracking-wider opacity-70">Community Trust</h6>
        <Link to="/trust" className="link link-hover">Trust Overview</Link>
        <Link to="/trustees" className="link link-hover">Meet the Trustees</Link>
        <Link to="/history" className="link link-hover">Our History</Link>
        <Link to="/community" className="link link-hover">Community Projects</Link>
      </nav>

      <nav>
        <h6 className="footer-title uppercase text-xs font-bold tracking-wider opacity-70">Social Club</h6>
        <Link to="/social" className="link link-hover">Social Hub</Link>
        <Link to="/social/booking" className="link link-hover">Function Suite Hire</Link>
        <Link to="/trustees" className="link link-hover">Trustees & Management</Link>
        <Link to="/contact#social" className="link link-hover">Social Enquiries & Hours</Link>
      </nav>

      <nav>
        <h6 className="footer-title uppercase text-xs font-bold tracking-wider opacity-70">Information & Legal</h6>
        <Link to="/about" className="link link-hover">About Us</Link>
        <Link to="/contact" className="link link-hover">Contact Us</Link>
        <Link to="/terms" className="link link-hover">Terms & Conditions</Link>
        <Link to="/privacy" className="link link-hover">Privacy Policy</Link>
      </nav>
    </footer>
  );
};

export default Footer;
